document.addEventListener('DOMContentLoaded', function () {
	let betonCheckboxes = document.querySelectorAll('.table-beton .ch-data-attr');

	for(let c of betonCheckboxes) {
		c.onchange = function () {
			let btn = this.closest('tr').querySelector('.btn-modal-request');
			btn.dataset[this.name] = this.checked;
		}
	}
});